import { render, staticRenderFns } from "./SideBarOrders.vue?vue&type=template&id=dc0bbb50"
import script from "./SideBarOrders.vue?vue&type=script&lang=js"
export * from "./SideBarOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports